import { render, staticRenderFns } from "./DeleteConfirmationDetails.vue?vue&type=template&id=c05f8d70&scoped=true&lang=pug&"
import script from "./DeleteConfirmationDetails.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05f8d70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
